module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_9-2a258e0e85fab3c646ccf7ae6ae5ed24.jpg";